import Vue from 'vue'

const data = Vue.observable({ video: {
  muted: true,
} })

Object.defineProperty(Vue.prototype, '$video', {
  get() {
    return data.video
  },
  
  set(value) {
    data.video = value
  },

  getMuted() {
    data.video.muted;
  },

  setMuted(value) {
    data.video.muted = value;
  },

  toggleMuted() {
    this.setMuted(this.getMuted());
  }
})

Object.defineProperty(Vue.prototype, '$video.muted', {
  get() {
    return data.video.muted
  },
  
  set(value) {
    data.video.muted = value
  },

  toggleMuted() {
    this.setMuted(this.getMuted());
  }
})
